import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';
import { Strategy } from '../../Utilis/Types/Strategies';

const initialState: {
  strategies: Strategy | [];
} = {
  strategies: [],
};

const strategiesSlice = createSlice({
  name: 'strategies',
  initialState,
  reducers: {
    setStrategies(state, action: PayloadAction<Strategy>) {
      state.strategies = action.payload;
    },
  },
});

export const strategiesSelector = (state: RootState) =>
  state.strategies.strategies;

export const { setStrategies } = strategiesSlice.actions;

export default strategiesSlice.reducer;
